import Vue from 'vue'

const MESSAGE_MAX_LENGTH = 300;
const state = {
    // 
}

const getters = {
    // 
}

const rejectError = (reject, error) => {
    let message = error;
    if (error.response) {
        message = error.response;
        if (error.response.data) {
            message = error.response.data;
        }
        if (error.response.data.message) {
            message = error.response.data.message;
        }
    }

    if (message.length > MESSAGE_MAX_LENGTH) {
        message = message.substr(0, MESSAGE_MAX_LENGTH) + '...';
    }
    reject(message)
}

// EventSource consomme uniquement les petits états de progression.
// Aucun document Elasticsearch ni contenu CSV/XLSX ne passe par JavaScript.
const followServerExport = (url, onProgress, signal) => new Promise((resolve, reject) => {
    if (typeof EventSource === "undefined") {
        reject(new Error("Le navigateur ne prend pas en charge le suivi d'export."));
        return;
    }
    let source = null;
    let failures = 0;
    let settled = false;
    const close = () => {
        if (source) source.close();
        if (signal) signal.removeEventListener("abort", cancel);
    };
    const cancel = () => {
        if (settled) return;
        settled = true;
        close();
        reject(new Error("Suivi fermé. La génération continue sur le serveur."));
    };
    if (signal && signal.aborted) { cancel(); return; }
    source = new EventSource(url);
    if (signal) signal.addEventListener("abort", cancel, { once: true });
    source.onopen = () => { failures = 0; };
    source.onmessage = event => {
        if (settled) return;
        try {
            const status = JSON.parse(event.data);
            if (status.state === "failed") {
                const error = new Error(status.message || "La préparation de l'export a échoué.");
                error.exportState = "failed";
                throw error;
            }
            if (!["queued", "processing", "finalizing", "ready"].includes(status.state) ||
                !Number.isSafeInteger(status.loaded) || status.loaded < 0 ||
                !(status.total === null || (Number.isSafeInteger(status.total) && status.total >= status.loaded))) {
                throw new Error("La progression de l'export est invalide.");
            }
            if (status.state === "ready" && (status.total === null || status.loaded !== status.total ||
                typeof status.download_url !== "string" || !status.download_url || typeof status.filename !== "string")) {
                throw new Error("Le fichier exporté n'est pas prêt.");
            }
            if (typeof onProgress === "function") onProgress(status);
            if (status.state === "ready") { settled = true; close(); resolve(status); }
        } catch (error) { settled = true; close(); reject(error); }
    };
    source.onerror = () => {
        if (settled) return;
        failures++;
        // Les reconnects ne relancent jamais le POST ni le job serveur.
        if (source.readyState === 2 || failures >= 6) {
            settled = true;
            close();
            reject(new Error("Le suivi de l'export est interrompu. Le travail serveur continue."));
        }
    };
});

const actions = {
    elasticSearchRequest: async ({ commit, dispatch }, queries) => {
        return new Promise((resolve, reject) => {
            let url = '/api/elastic/search'
            Vue.axios.post(url, queries)
                .then((result) => {
                    resolve(result)
                })
                .catch((error) => {
                    rejectError(reject, error);
                })
        })
    },
    elasticDownloadRequest: async ({ commit, dispatch }, payload) => {
        const { onProgress, onStarted, signal, ...queries } = payload;
        try {
            // Un seul POST lance le job. Sa réponse ne contient aucun document.
            const result = await Vue.axios.post('/api/elastic/download', queries);
            if (!queries.server_export) return result;
            if (!result.data || typeof result.data.progress_url !== "string") {
                throw new Error("La réponse de lancement de l'export est invalide.");
            }
            if (typeof onStarted === "function") onStarted(result.data);
            const completed = await followServerExport(result.data.progress_url, onProgress, signal);
            return { ...result, data: completed };
        } catch (error) {
            return new Promise((resolve, reject) => rejectError(reject, error));
        }
    },
    elasticExportProgressRequest: async ({ commit, dispatch }, { progress_url, onProgress, signal }) => {
        // Reprendre un export existant ne crée ni un POST ni un nouveau job.
        return { data: await followServerExport(progress_url, onProgress, signal) };
    },
    elasticCreateRequest: async ({ commit, dispatch }, queries) => {
        return new Promise((resolve, reject) => {
            let url = '/api/elastic/create'
            Vue.axios.post(url, queries)
                .then((result) => {
                    resolve(result)
                })
                .catch((error) => {
                    rejectError(reject, error);
                })
        })
    },
    elasticGetRequest: async ({ commit, dispatch }, queries) => {
        return new Promise((resolve, reject) => {
            let url = '/api/elastic/get'
            Vue.axios.get(url, { params: queries })
                .then((result) => {
                    resolve(result)
                })
                .catch((error) => {
                    rejectError(reject, error);

                })
        })
    },
    elasticDeleteRequest: async ({ commit, dispatch }, queries) => {
        return new Promise((resolve, reject) => {
            let url = `/api/elastic/delete`;
            Vue.axios.delete(url, { params: queries })
                .then((result) => {
                    resolve(result)
                })
                .catch((error) => {
                    rejectError(reject, error);
                })
        })
    },
    /**
     * 
     * @param {*} payload let payload = {
        clientId: "5",
        site: "23",
        startDay: "01-01",
        endDay: "12-31",
        operations: [
          {
            op_type_day: "max",
            op_type_year: "sum",
            field_name: "TemperatureMaxiCelsius",
          },
          { op_type_day: "sum", op_type_year: "sum", field_name: "Precipitation_mm" },
          {
            op_type_day: "avg",
            op_type_year: "sum10",
            field_name: "TemperatureMoyCelsius",
          },
        ],
        cepage: "MN",
        events: ["MiFloraison", "MiVeraison"],
      }; 
     * @returns 
     */
    elasticNearestYearsRequest: async ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            let url = `/api/elastic/nearestyears`;
            Vue.axios.post(url, payload)
                .then((result) => {
                    resolve(result)
                })
                .catch((error) => {
                    rejectError(reject, error);
                })
        })
    },
}


const mutations = {
    // 
}

export default {
    state,
    getters,
    actions,
    mutations,
}
